import Swiper from "swiper";
import {MD_WIDTH} from "@main/helpers/const";

class AboutSlider {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        const swiper = new Swiper(this.el, {
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 8,
            initialSlide: 1,
            breakpoints: {
                [MD_WIDTH]: {
                    spaceBetween: 16
                }
            }
        });

        this.el.addEventListener("click", e => {
            const {target} = e;

            if (
                target.classList.contains("swiper-slide-prev") ||
                target.closest(".swiper-slide-prev")
            ) {
                swiper.slidePrev();
            }

            if (
                target.classList.contains("swiper-slide-next") ||
                target.closest(".swiper-slide-next")
            ) {
                swiper.slideNext();
            }

            return;
        });
    }
}

window.addEventListener("load", function() {
    document
        .querySelectorAll(".js-about-slider")
        .forEach(slider => new AboutSlider(slider));
});
